import React from 'react'
import { Layout, Typography, Space } from 'antd'
import {
  VideoCameraOutlined,
  PhoneOutlined,
  WechatOutlined
} from '@ant-design/icons'
// 链接布局简化后不再需要 Link、Row、Col、Divider 等

const { Footer: AntFooter } = Layout
const { Text } = Typography

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()

  // 复杂链接分栏已移除

  return (
    <AntFooter className="hidden md:block bg-gray-900 text-white" style={{ padding: '12px 0', minHeight: 'auto' }}>
      <div className="container-max px-4 md:px-6 py-2">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 bg-gradient-to-r from-blue-500 to-purple-600 rounded flex items-center justify-center">
              <VideoCameraOutlined className="text-white text-sm" />
            </div>
            <Text className="text-gray-300 text-xs">
              v{__APP_VERSION__} © {currentYear} Sora2 AI Platform
            </Text>
          </div>

          <div className="flex items-center gap-3 text-gray-400 text-sm">
            <PhoneOutlined />
            <span>客服热线 / 微信：86244355</span>
          </div>
          <div className="text-gray-400 text-xs">
            京ICP备12345678号-1 | 京公网安备11010502012345号
          </div>
        </div>
      </div>
    </AntFooter>
  )
}

export default Footer
